import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=4bc9ef18&"
import script from "./Playground.vue?vue&type=script&setup=true&lang=js&"
export * from "./Playground.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Playground.vue?vue&type=style&index=0&id=4bc9ef18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports